import { initI18n } from "@flare/i18n";

import enUSTranslations from "@/../public/locales/en-US/translation.json";

export const i18n = initI18n();
i18n.addResourceBundle("en-US", "translation", enUSTranslations);
